
import Card from '../../../components/base/Card';

export default function ContactSection() {
  const contactMethods = [
    {
      icon: 'ri-mail-line',
      title: 'Email',
      description: 'Drop me a line anytime',
      value: 'ethanlevine123@gmail.com',
      action: 'mailto:ethanlevine123@gmail.com'
    },
    {
      icon: 'ri-linkedin-line',
      title: 'LinkedIn',
      description: 'Connect professionally',
      value: 'Connect with me',
      action: 'https://www.linkedin.com/in/ethanlevine123/'
    },
    {
      icon: 'ri-phone-line',
      title: 'Phone',
      description: 'Let\'s have a conversation',
      value: '(571) 245-8001',
      action: 'tel:+15712458001'
    }
  ];

  return (
    <section 
      id="contact" 
      className="py-20 bg-cover bg-center bg-fixed relative"
      style={{
        backgroundImage: `linear-gradient(rgba(255, 255, 255, 0.92), rgba(255, 255, 255, 0.92)), url('https://public.readdy.ai/ai/img_res/4ca7926fa84be252a12fc29f03a0dd65.jpg')`
      }}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
            Ready to Team Up?
          </h2>
          <div className="w-20 h-1 bg-blue-600 mx-auto mb-6"></div>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto italic">
            "'You miss 100% of the shots you don't take.' - Wayne Gretzky" - Michael Scott
          </p>
        </div>

        <div className="grid lg:grid-cols-3 gap-8">
          {contactMethods.map((method, index) => (
            <Card key={index} className="text-center hover:scale-105 transition-transform duration-300 bg-white/90 backdrop-blur-sm">
              <div className="w-16 h-16 flex items-center justify-center bg-blue-100 rounded-full mx-auto mb-4">
                <i className={`${method.icon} text-2xl text-blue-600`}></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-2">{method.title}</h3>
              <p className="text-gray-600 mb-3">{method.description}</p>
              <a 
                href={method.action}
                className="text-blue-600 hover:text-blue-700 font-medium cursor-pointer"
                target={method.action.startsWith('http') ? '_blank' : undefined}
                rel={method.action.startsWith('http') ? 'noopener noreferrer' : undefined}
              >
                {method.value}
              </a>
            </Card>
          ))}
        </div>
      </div>
    </section>
  );
}
